import { msTeamsChannels } from 'infra/redux/reducers'

export const ENDPOINTS = [
  'accesspolicys',
  'accounts',
  'accountcheck',
  'adDomainControllers',
  'appgroups',
  'applications',
  'approles',
  'approvalreqs',
  'approvers',
  'attachments',
  'authzactioncheck',
  'awsresources',
  'azureresources',
  'bookmarks',
  'carts',
  'cloudactions',
  'connectors',
  'credentials',
  'credentialtypes',
  'databases',
  'devices',
  'elasticlog',
  'gcpresources',
  'scm-account',
  'scmresources',
  'googleidproviders',
  'groups',
  'iamactions',
  'idpsecretrefresh',
  'idproviders',
  'jiraintegrations',
  'jiraprojects',
  'kubenamespaces',
  'kafkas',
  'medusanodes',
  'msTeamsIntegrations',
  'msTeams',
  'msTeamsChannels',
  'notificationsubscriptions',
  'objaccesscheck',
  'objactions',
  'onboardtokens',
  'orgs',
  'pacpolicys',
  'paapolicys',
  'proxies',
  'proxytokens',
  'projects',
  'regions',
  'scimservers',
  'servergroups',
  'servers',
  'serviceaccounts',
  'sessionmgmt',
  'slackchannels',
  'slackintegrations',
  'sshca',
  'servicenowintegrations',
  'servicenowtables',
  'tagpolicys',
  'targetgroups',
  'targets',
  'tenants',
  'tenantapikeys',
  'tenantprofiles',
  'tenantsiemconfigs',
  'tenantsiemconfigs-healthcheck',
  'tgws',
  'userpreferences',
  'users',
  'vpcs',
  'workloadidentitys',
  'workloadtokens',
  'rdpservers',
  'kubeclusters',
  'salesforce-users',
  'salesforce-account',
  'crm-entities',
  'snowflakeresources',
  'access-grants',
  'gsuites',
  'shadowaipolicys',
  'secretstoreaccounts',
  'secrets',
  'secrettemplates',
  'cloudagents',
  'aiagentaccounts',
  'agentaccesskeys',
  'aipolicys',
  'agentapprovals',
  'agentkeyusage',
  'uservaults'
]
//prettier-ignore
export const MAP_KIND_TO_ENDPOINT = {
  Account                   : 'accounts',
  Application               : 'applications',
  AppRole                   : 'approles',
  ApprovalReq               : 'approvalreqs',
  Approver                  : 'approvers',
  Attachment                : 'attachments',
  AwsResource               : 'awsresources',
  AzureResource             : 'azureresources',
  Bookmark                  : 'bookmarks',
  Cart                      : 'carts',
  CloudAction               : 'cloudactions',
  Database                  : 'databases',
  Device                    : 'devices',
  ElasticLog                : 'elasticlog',
  GcpResource               : 'gcpresources',
  ScmAccount                : 'scm-account',
  ScmResource               : 'scmresources',
  // Legacy kind names still referenced by UI code (github feature); the
  // backend objects now carry Kind ScmAccount/ScmResource.
  GithubAccount             : 'scm-account',
  GithubResource            : 'scmresources',
  GoogleIdProvider          : 'googleidproviders',
  Group                     : 'groups',
  IamAction                 : 'iamactions',
  IdProvider                : 'idproviders',
  JiraIntegration           : 'jiraintegrations',
  JiraProject               : 'jiraprojects',
  KubeNamespace             : 'kubenamespaces',
  Kafka                     : 'kafkas',
  KubeCluster               : 'kubeclusters',
  MedusaNode                : 'medusanodes',
  MsTeamsIntegrations       :'msTeamsIntegrations',
  MattermostIntegration     : 'mattermostintegrations',
  MsTeams                   :'msTeams',
  msTeamsChannels           :'msTeamsChannels',
  NotificationSubscription  : 'notificationsubscriptions',
  ObjAccessCheck            : 'objaccesscheck',
  ObjAction                 : 'objactions',
  OnboardToken              : 'onboardtokens',
  Org                       : 'orgs',
  PacPolicy                 : 'pacpolicys',
  PaaPolicy                 : 'paapolicys',
  Project                   : 'projects',
  RDPServer                 : 'rdpservers',
  Server                    : 'servers',
  ServiceAccount            : 'serviceaccounts',
  SlackChannel              : 'slackchannels',
  SlackIntegration          : 'slackintegrations',
  ServicenowIntegration     : 'servicenowintegrations',
  ServicenowTable           : 'servicenowtables',
  TagPolicy                 : 'tagpolicys',
  TargetGroup               : 'targetgroups',
  Target                    : 'targets',
  Tenant                    : 'tenants',
  TenantApikey              : 'tenantapikeys',
  TenantProfile             : 'tenantprofiles',
  TenantSiemConfig          : 'tenantsiemconfigs',
  Tgw                       : 'tgws',
  UserPreference            : 'userpreferences',
  User                      : 'users',
  Vpc                       : 'vpcs',
  WorkloadIdentity          : 'workloadidentitys',
  WorkloadToken             : 'workloadtokens',
  SalesforceUsersList       : 'salesforce-users',
  SalesForceAccountList     : 'salesforce-account',
  SalesForcePermissionList  : 'crm-entities',
  SnowFlakeResources        : 'snowflakeresources',
  DatabricksResource        : 'databricksresources',
  GSuite                    : 'gsuites',
  ShadowAIPolicy            : 'shadowaipolicys',
  SecretStoreAccount        : 'secretstoreaccounts',
  Secret                    : 'secrets',
  SecretTemplate            : 'secrettemplates',
  CloudAgent                : 'cloudagents',
  AIAgentAccount            : 'aiagentaccounts',
  AgentAccessKey            : 'agentaccesskeys',
  AIPolicy                  : 'aipolicys',
  AgentApproval             : 'agentapprovals',
  AgentKeyUsage             : 'agentkeyusage',
  UserVault                 : 'uservaults',
  AccessGrant               : 'access-grants'
}

export const KindToEndpointMap = MAP_KIND_TO_ENDPOINT
//prettier-ignore
export const MAP_ENDPOINT_TO_KIND = {
  accounts                   : 'Account',
  applications               : 'Application',
  approles                   : 'AppRole',
  approvalreqs               : 'ApprovalReq',
  approvers                  : 'Approver',
  attachments                : 'Attachment',
  awsresources               : 'AwsResource',
  azureresources             : 'AzureResource',
  bookmarks                  : 'Bookmark',
  carts                      : 'Cart',
  cloudactions               : 'CloudAction',
  databases                  : 'Database',
  devices                    : 'Device',
  elasticlog                 : 'ElasticLog',
  gcpresources               : 'GcpResource',
  'scm-account'              : 'ScmAccount',
  scmresources               : 'ScmResource',
  googleidproviders          : 'GoogleIdProvider',
  groups                     : 'Group',
  iamactions                 : 'IamAction',
  idproviders                : 'IdProvider',
  jiraintegrations           : 'JiraIntegration',
  jiraprojects               : 'JiraProject',
  kubenamespaces             : 'KubeNamespace',
  kafkas                     : 'Kafka',
  kubeclusters               : 'KubeCluster',
  medusanodes                : 'MedusaNode',
  notificationsubscriptions  : 'NotificationSubscription',
  objaccesscheck             : 'ObjAccessCheck',
  objactions                 : 'ObjAction',
  onboardtokens              : 'OnboardToken',
  orgs                       : 'Org',
  pacpolicys                 : 'PacPolicy',
  paapolicys                 : 'PaaPolicy',
  projects                   : 'Project',
  rdpservers                 : 'RDPServer',
  servers                    : 'Server',
  serviceaccounts            : 'ServiceAccount',
  slackchannels              : 'SlackChannel',
  slackintegrations          : 'SlackIntegration',
  servicenowintegrations     : 'ServicenowIntegration',
  servicenowtables           : 'ServicenowTable',
  tagpolicys                 : 'TagPolicy',
  targetgroups               : 'TargetGroup',
  targets                    : 'Target',
  tenants                    : 'Tenant',
  tenantapikeys              : 'TenantApikey',
  tenantprofiles             : 'TenantProfile',
  tenantsiemconfigs          : 'TenantSiemConfig',
  tgws                       : 'Tgw',
  userpreferences            : 'UserPreference',
  users                      : 'User',
  vpcs                       : 'Vpc',
  workloadidentitys          : 'WorkloadIdentity',
  workloadtokens             : 'WorkloadToken',
  'salesforce-users'         : 'SalesForceUsersList',
  'salesforce-account'       : 'SalesForceAccountList',
  'crm-entities'             : 'SalesForcePermissionList',
  snowflakeresources         : 'SnowFlakeResources',
  msTeamsIntegrations        : 'MsTeamsIntegrations', 
  msTeams                    : 'MsTeams',
  msTeamsChannels            : 'MsTeamsChannels',
  databricksresources        : 'dataBricksResources',
  gsuites                    : 'GSuite',
  shadowaipolicys            : 'ShadowAIPolicy',
  secretstoreaccounts        : 'SecretStoreAccount',
  secrets                    : 'Secret',
  secrettemplates            : 'SecretTemplate',
  cloudagents                : 'CloudAgent',
  aiagentaccounts            : 'AIAgentAccount',
  agentaccesskeys            : 'AgentAccessKey',
  aipolicys                  : 'AIPolicy',
  agentapprovals             : 'AgentApproval',
  agentkeyusage              : 'AgentKeyUsage',
  uservaults                 : 'UserVault',
  'access-grants'            : 'AccessGrant'
}

/**
 * Endpoints which only exists on default namespace
 */
export const DEFAULT_NAMESPACE_ONLY_ENDPOINT_MAP = {
  bookmarks: true,
  shadowaipolicys: true,
  carts: true,
  orgs: true,
  users: true,
  devices: true,
  userpreferences: true,
  iamactions: true,
  tenants: true,
  tenantapikeys: true,
  tenantprofiles: true,
  tenantsiemconfigs: true,
  'tenantsiemconfigs-healthcheck': true,
  medusanodes: true,
  proxies: true,
  onboardtokens: true,
  googleidproviders: true,
  idproviders: true,
  idpsecretrefresh: true,
  awsresources: true,
  secretstoreaccounts: true,
  secrets: true,
  secrettemplates: true,
  agentaccesskeys: true,
  aipolicys: true,
  agentapprovals: true,
  agentkeyusage: true
}

/**
 * For these endpoints, when getAll() is called, the namespace query param will be removed.
 */
export const FETCH_ALL_WHEN_ADMIN_ENDPOINTS = {
  accounts: true
}

/**
 * Endpoints fetched with cursor pagination (ObjectMeta.QueryParam) instead of one
 * unpaginated GET. The first page renders early at firstPageSize; the remaining
 * pages are walked at walkPageSize until the cursor (first row's
 * ObjectMeta.QueryParam) disappears — the list envelope carries no total count.
 */
export const PAGINATED_ENDPOINTS = {
  approles: { firstPageSize: 100, walkPageSize: 500, maxPages: 200 },
  // ScmResources (github/gitlab repos + teams): real orgs carry 1k+ rows in a
  // single unpaginated 2.5MB response that blocks the main thread when
  // rendered (Repositories tab "Page Unresponsive"). Walk with the cursor
  // instead — the backend's QueryByOffset already speaks page_state.
  scmresources: { firstPageSize: 100, walkPageSize: 500, maxPages: 200 }
}

/**
 * ENDPOINTS which are public as opposed to private endpoints like other endpoints
 * PUBLIC endpoints uses: 'pubapi' prefix
 * PRIVATE endpoints uses: 'api'
 */
export const PUBLIC_ENDPOINTS = []
